var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 182.12604 229.80245",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.0874 -68.997)",
    fill: "none",
    strokeDashoffset: 100,
    strokeWidth: 0.52917
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.082,
    y: 139.1,
    width: 20.836,
    height: 158.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.9,
    y: 70.258,
    width: 20.874,
    height: 227.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.98,
    y: 78.225,
    width: 20.873,
    height: 219.31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.17716,
    y: 192.03,
    width: 20.812,
    height: 105.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.eec8c52e95d3011a7998fa8c3ad47b9b.svg";
export { ForwardRef as ReactComponent };